import { render, staticRenderFns } from "./UserHoursTab.vue?vue&type=template&id=09034b5c&"
import script from "./UserHoursTab.vue?vue&type=script&lang=js&"
export * from "./UserHoursTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserHoursTab.vue"
export default component.exports